module.exports = __webpack_public_path__ + "static/media/block1右侧直播宣传.c61d026e.png";